import { RouteRecordRaw } from 'vue-router'

import { SHOW_ROUTE_NAMES } from '@/modules/show/constants/ShowRouteName'

import { UserGroup } from '@generated/types'

export const showRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/shows',
    name: 'showList',
    redirect: { name: SHOW_ROUTE_NAMES.LIST },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Show List',
    },
  },
  {
    path: '/venue/shows/add',
    name: 'showAdd',
    redirect: { name: SHOW_ROUTE_NAMES.CREATE },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Add Show',
    },
  },
  {
    path: '/venue/shows/:id',
    name: 'showDetail',
    redirect(to) {
      return { name: SHOW_ROUTE_NAMES.DETAIL, params: { showId: +to.params.id } }
    },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Show Detail',
    },
  },
  {
    path: '/venue/shows/:id/edit',
    name: 'showEdit',
    redirect(to) {
      return { name: SHOW_ROUTE_NAMES.EDIT, params: { showId: +to.params.id } }
    },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Edit Show',
    },
  },
  {
    path: '/venue/shows/:showId/performance/add',
    name: 'performanceAdd',
    component: () => import('@/modules/show/pages/ShowPerformanceAdd.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Add Performance',
    },
  },
  {
    path: '/venue/show/',
    component: () => import('@/modules/show/layouts/ShowLayout.vue'),
    props: route => ({ showId: +route.params.showId || undefined }),
    meta: { requiresAuth: UserGroup.MANAGERS, pageTitle: 'Shows' },
    children: [
      {
        path: '',
        name: SHOW_ROUTE_NAMES.LIST,
        component: () => import('@/modules/show/pages/ShowList.vue'),
        meta: {
          requiresAuth: UserGroup.MANAGERS,
          pageTitle: 'Show List',
        },
      },
      {
        path: 'create',
        name: SHOW_ROUTE_NAMES.CREATE,
        component: () => import('@/modules/show/pages/ShowCreate.vue'),
        meta: {
          requiresAuth: UserGroup.MANAGERS,
          pageTitle: 'Show Create',
        },
      },
      {
        path: ':showId',
        name: SHOW_ROUTE_NAMES.DETAIL,
        component: () => import('@/modules/show/pages/ShowDetail.vue'),
        props: route => ({ showId: +route.params.showId }),
        meta: {
          requiresAuth: UserGroup.MANAGERS,
          pageTitle: 'Show Detail',
        },
      },
      {
        path: ':showId/edit',
        name: SHOW_ROUTE_NAMES.EDIT,
        component: () => import('@/modules/show/pages/ShowEdit.vue'),
        props: route => ({ showId: +route.params.showId }),
        meta: {
          requiresAuth: UserGroup.MANAGERS,
          pageTitle: 'Show Edit',
        },
      },
    ],
  },
]
